/**
 * Places the LDT Gift Wrap app widget beside the quantity selector to prevent layout shift.
 */
const SLOT_SELECTOR = '.product-gift-wrap-slot';
const GIFT_WRAP_PATTERN = /ギフト|包装|gift\s*wrap/i;

/**
 * @param {Element} root
 * @returns {Element | null}
 */
function findGiftWrapWidget(root) {
  for (const block of root.querySelectorAll('shopify-app-block')) {
    const markup = block.outerHTML;
    if (markup.includes('ldt-gift-wrap') || GIFT_WRAP_PATTERN.test(block.textContent || '')) {
      return block;
    }
  }

  for (const element of root.querySelectorAll('[class*="ldt"], [id*="ldt"]')) {
    if (element.closest(SLOT_SELECTOR)) continue;
    const widget = element.closest('shopify-app-block') || element;
    if (GIFT_WRAP_PATTERN.test(widget.textContent || '') || /ldt/i.test(`${widget.className} ${widget.id}`)) {
      return widget;
    }
  }

  for (const label of root.querySelectorAll('label')) {
    if (!GIFT_WRAP_PATTERN.test(label.textContent || '')) continue;
    if (label.closest(SLOT_SELECTOR)) continue;
    return (
      label.closest('[class*="ldt-gw"]') ||
      label.closest('shopify-app-block') ||
      label.parentElement
    );
  }

  return null;
}

/**
 * @param {Element} buttons
 */
function setupProductFormButtons(buttons) {
  const slot = buttons.querySelector(SLOT_SELECTOR);
  if (!slot) return;

  const productForm = buttons.closest('product-form-component');
  const searchRoot = productForm || buttons;

  const relocate = () => {
    let widget = slot.firstElementChild;

    if (!widget) {
      widget = findGiftWrapWidget(searchRoot);
    }

    if (!widget) return;

    const widgetForm = widget.closest('product-form-component');
    if (productForm && widgetForm && widgetForm !== productForm) return;

    if (!slot.contains(widget)) {
      slot.replaceChildren(widget);
    }

    slot.classList.remove('product-gift-wrap-slot--reserve');
  };

  relocate();

  const observer = new MutationObserver(relocate);
  observer.observe(searchRoot, { childList: true, subtree: true });

  if (searchRoot !== document.body) {
    observer.observe(document.body, { childList: true, subtree: true });
  }
}

function init() {
  document.querySelectorAll('.product-form-buttons').forEach(setupProductFormButtons);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}

document.addEventListener('shopify:section:load', init);
